import { render, staticRenderFns } from "./carDetail.vue?vue&type=template&id=beb1bd1e&scoped=true&"
import script from "./carDetail.vue?vue&type=script&lang=js&"
export * from "./carDetail.vue?vue&type=script&lang=js&"
import style0 from "./carDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./carDetail.vue?vue&type=style&index=1&id=beb1bd1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb1bd1e",
  null
  
)

export default component.exports